import { render, staticRenderFns } from "./CompetencesNotConnectedWithSkillsTab.vue?vue&type=template&id=b5871442&scoped=true&"
import script from "./CompetencesNotConnectedWithSkillsTab.vue?vue&type=script&lang=js&"
export * from "./CompetencesNotConnectedWithSkillsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5871442",
  null
  
)

export default component.exports